<template>
<div>
  <div style="color:#606266;height:50px;width:100%;background-color:#E4E7ED;text-align:left;font-size:16px;line-height:50px;font-weight:bold;padding-left:10px;">问卷规则</div>
  <div style="padding:20px;border-left:1px solid #E4E7ED;border-right:1px solid #E4E7ED;">
    <el-form ref="form" :model="form" :rules="rules" label-width="200px" class="ques_relus">
      <el-form-item label="问卷最大连续相同结果值">
        <el-tooltip effect="dark" content="当连续多少道题评分一致，则判定为无效问卷，请配置为大于等于0的整数，0表示不控制。" placement="top-start">
          <el-input v-model="form.continuous_num" placeholder="即连续多少道题评分一致，则判定为无效问卷，0表示不控制"></el-input>
        </el-tooltip>
      </el-form-item>
    </el-form>
  </div>
  <div style="color:#606266;height:50px;width:100%;background-color:#E4E7ED;text-align:left;font-size:16px;line-height:50px;font-weight:bold;padding-left:10px;">评估人条件</div>
  <div style="padding:20px;border-left:1px solid #E4E7ED;border-right:1px solid #E4E7ED;border-bottom:1px solid #E4E7ED;">
  <el-table
    :data="Assessor_conditions"
    style="width: 100%">
    <el-table-column
      prop="user_type"
      label="评估人类型"
      min-width="30%">
    </el-table-column>
    <el-table-column
      prop="is_part_in"
      label="是否参与评估"
      min-width="40%">
      <template slot-scope="scope">
          <el-select v-model="scope.row.configurationChecked" placeholder="是" value-key="index" filterable>
          <el-option v-for="(item,index) in scope.row.is_part_in"
          :key="index" :label="item.configuration" :value="item"></el-option>
          </el-select>
      </template>
    </el-table-column>
    <el-table-column
      prop="weight"
      label="评分所占权重"
      min-width="30%">
      <template slot-scope="scope">
          <el-input-number v-model="scope.row.weight" controls-position="right" :min="0" :max="100"></el-input-number>
          <span> %</span>
      </template>
    </el-table-column>
  </el-table>
  <div style="margin-top:20px;">
  <!-- <el-button @click="Cancel_config">取消</el-button> -->
  <el-button type="primary" @click="Submit_config">保存</el-button>
  </div>
  </div>
</div>
</template>

<script>
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
export default {
    created() {
      this.Cancel_config();
    },
    data() {
        return {
          form: {
              continuous_num: 0,
          },
          rules: {
            // trigger类型为blur的功能是文本框失去焦点才会触发
            // trigger类型为change的功能是文本框在输入内容时触发
            continuous_num: [
              {required: true, message: '请配置为大于等于0的整数！', trigger: 'blur'},
              {type: 'integer', message: '请配置为大于等于0的整数！', trigger: 'blur'},
            ],
          },
          // 参数表中的参数由前台直接定义，不从后台读取了，前台配置后提交后台入库
          Assessor_conditions: [{
            user_type: '本人',
            is_part_in: ['是','否'],
            weight: 0,
            configurationChecked: '是',
            params: [{
                para_name: 'self_part_in',
                zh_name: '本人是否参与评估',
            },{
                para_name: 'self_percent',
                zh_name: '本人评分所占权重',
            }],
          }, {
            user_type: '上级',
            is_part_in: ['是','否'],
            weight: 40,
            configurationChecked: '是',
            params: [{
                para_name: 'superior_part_in',
                zh_name: '上级是否参与评估',
            },{
                para_name: 'superior_percent',
                zh_name: '上级评分所占权重',
            }],
          }, {
            user_type: '直接下级',
            is_part_in: ['是','否'],
            weight: 30,
            configurationChecked: '是',
            params: [{
                para_name: 'subordinate_part_in',
                zh_name: '下级是否参与评估',
            },{
                para_name: 'subordinate_percent',
                zh_name: '下级评分所占权重',
            }],
          }, {
            user_type: 'peer',
            is_part_in: ['是','否'],
            weight: 30,
            configurationChecked: '是',
            params: [{
                para_name: 'peer_part_in',
                zh_name: 'peer是否参与评估',
            },{
                para_name: 'peer_percent',
                zh_name: 'peer评分所占权重',
            }],
          }],
          params_info: {},
        }
      },
      props: ['task_id'],
      methods: {
        Cancel_config() {
          // 取消即从服务器获取此前已保存的配置，并覆盖当前的配置
          let params;
          params = {
              'task_id': this.task_id,
          }
          getdata.getListP("getManaConfigs", params)
            .then(resp => {
                if(resp.data.code == 200){
                    var result = resp.data.data;
                    for(var i in this.Assessor_conditions){
                      this.Assessor_conditions[i]['configurationChecked'] = result[this.Assessor_conditions[i]['params'][0]['para_name']];
                      this.Assessor_conditions[i]['weight'] = result[this.Assessor_conditions[i]['params'][1]['para_name']]
                    }
                    this.form.continuous_num = result['continuous_num'];
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        Submit_config() {
          var para_name = [];
          var para_value = [];
          var zh_name = [];
          var weight_value = [];
          for(var i in this.Assessor_conditions){
            para_name.push(this.Assessor_conditions[i]['params'][0]['para_name']);
            zh_name.push(this.Assessor_conditions[i]['params'][0]['zh_name']);
            para_value.push(this.Assessor_conditions[i]['configurationChecked']);

            para_name.push(this.Assessor_conditions[i]['params'][1]['para_name']);
            zh_name.push(this.Assessor_conditions[i]['params'][1]['zh_name']);
            // console.log("weight" + i + ": " + this.Assessor_conditions[i]['weight']);
            // console.log("is number: " + (typeof this.Assessor_conditions[i]['weight'] === 'number'));
            // 未填写权重时，默认为0
            if(this.Assessor_conditions[i]['weight'] === undefined){
              this.Assessor_conditions[i]['weight'] = 0;
            }
            para_value.push(this.Assessor_conditions[i]['weight']);
            weight_value.push(this.Assessor_conditions[i]['weight']);
          }
          var weight_sum = 0;
          for(var w in weight_value){
              weight_sum = weight_sum + weight_value[w];
          }
          if(weight_sum != 100){
            this.$message({
              message: '权重配置错误，权重之和应为100%！',
              type: 'error',
              duration: 2000,
            })
            return;
          }
          this.params_info['para_name'] = para_name;
          this.params_info['para_value'] = para_value;
          this.params_info['zh_name'] = zh_name;
          this.params_info['task_id'] = this.task_id;
          this.params_info['continuous_num'] = this.form.continuous_num;
          // 将当前页面的配置保存到后台
          postdata.postList("submitManaConfigs", JSON.stringify(this.params_info))
              .then(resp => {
                if(resp.data.code == 200){
                  this.$message({
                    message: resp.data.message,
                    type: "success",
                  })
                }else{
                  this.$message({
                    message: resp.data.message,
                    type: "error",
                    duration: 6000,
                    // showClose: true,
                  })
                }
              })
              .catch(err => {
                console.log(err);
              })
        }
      }
}
</script>

<style scoped>
.el-table {
    /* font-size: 18px; */
    margin-top: 10px;
}
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
/* ::v-deep .el-input {
    font-size: 18px;
} */
.el-button {
    font-size: 16px;
}
::v-deep .el-table__header {
    font-size: 16px;
}
.ques_relus {
  text-align: left;
}
.ques_relus /deep/ .el-input {
  width: 500px;
}
</style>